const UserNameDirective = function (Security) {
    return {
        restrict: 'E',
        template: '<span>{{ userName }}</span>',
        scope: {
            id: '=?',
            name: '=?',
            def: '@?'
        },
        link: function (scope) {
            scope.def = scope.def || "??";
            scope.userName = scope.name || scope.def;

            if (!scope.id && !scope.name) {
                return;
            }

            Security.get(scope.id, scope.name)
                .then(function (result) {
                    scope.userName = result.data.FullName || scope.def;
                }, function () {
                    scope.userName = scope.def;
                });
        }
    }
};

UserNameDirective.$inject = ["Security"];

export { UserNameDirective };